import _ from 'lodash';

export function getImageUrl(imageApiObj) {
  if (_.isString(imageApiObj)) {
    return imageApiObj;
  }
  return _.get(imageApiObj, 'fullSize.url');
}

export function getImageSize(imageApiObj) {
  const data = _.get(imageApiObj, 'fullSize');

  if (!data) return null;

  const {height, width} = data;
  return {height, width};
}

export function createImgObject(url) {
  return {fullSize: {url}};
}